module.exports = __webpack_public_path__ + "img/Economy.4b338db9.png";